module.exports = __webpack_public_path__ + "static/media/firstpasslogo.d7db7218.svg";